import { GET_COURSE_NUMBERS } from "../../../../enums/Request/request.types";

export const getCourseNumbersAction = (data) => {
    return {
        type: GET_COURSE_NUMBERS,
        payload: data,
    };
};
